import { configureStoreProd, configureStoreDev } from './configureStore';

export const configureStore = (s = {}) =>
  process.env.NODE_ENV === 'production'
    ? configureStoreProd(s || {})
    : configureStoreDev(s || {});

export { configureStore as default };
